import {  CodeListDto } from "@gtpl/shared-models/planning";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllCodeListResponseModel extends GlobalResponseObject {
    data?: CodeListDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CodeListDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

